import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPhoneVolume } from 'react-icons/fa';
import { MdLocationOn, MdOutlineEmail } from 'react-icons/md';
import { Button, Col, Row } from 'react-bootstrap';
import CenterStage from '../../Components/CenterStage/CenterStage';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import FeatureCardCarousel from '../../Components/FeaturesCardCarousal/FeatureCardCarousal';
import ShowcaseCarousel from '../../Components/ShowcaseCarousel/ShowcaseCarousel';
import FullImageText from '../../Components/FullImageText/FullImageText';

import imgStage from '../../assets/WhoWeAre/stage.jpg';
import imgService from '../../assets/WhoWeAre/service.jpg';
import hose from '../../assets/HoseLogo.png';
import imgCartons from '../../assets/Hansa-Flex_Kartons_Shop.png';
import imgSerbai_Celeb1 from '../../assets/WhoWeAre/Serbai_Celeb1.jpg';
import imgSerbai_Celeb2 from '../../assets/WhoWeAre/Serbai_Celeb2.jpg';
import imgSerbia_service_van from '../../assets/WhoWeAre/Serbia_service_van.jpg';
import imgSerbia_service_car from '../../assets/WhoWeAre/Serbia_service_car.jpg';

import imgVan from '../../assets/brandImages/Services_MHS_Kanalseite_01.jpg';
import imgLogistics from '../../assets/LogisticsImg.jpg';
import imgCustomerSupport from '../../assets/customer-support.png';
import imgSerbiaWhoweare from '../../assets/WhoWeAre/SerbiaWhoweare.png'
import imgHANSA_FLEX_SERBIA_STAGE from '../../assets/Home/HANSA_FLEX_SERBIA_STAGE.jpg'
import ThreeDImageCarousel from '../../Components/CircleCarousel/CircleCarousel';
import imgCylinder from '../../assets/Branch/Cylinder/Cylinder1.jpg';
import imgCylinder2 from '../../assets/Branch/Cylinder/Cylinder3.jpg';
import imgCylinder3 from '../../assets/Branch/Cylinder/Cylinder7.jpg';

function WhoWeAre() {
    const { t } = useTranslation();

    // features card carousel data
    const carouselData = [
        {
            image: imgSerbai_Celeb1,
        },
        {
            image: imgCylinder3,
        },
        {
            image: imgSerbai_Celeb2,
        },
        {
            image: imgCylinder,
        },
        {
            image: imgSerbia_service_car,
        },
        {
            image: imgCylinder2,
        },
        {
            image: imgVan,
        },
    ]
    const featuresData = [
        {
            title: "Customer support",
            description: "Offering expert advice and assistance to our customers in Serbia.",
            image: imgCustomerSupport
        },
        {
            title: "Extensive stock availability",
            description: "We have stocks of products around 13000 units!",
            image: imgCartons
        },
        {
            title: "Premium quality hoses",
            description: "Experience our unmached Quality",
            image: hose
        }
        // Add more objects for additional FeaturesCard data
    ];

    const carouselItems = [
        {
            imgSrc: imgService,
            title: 'Easy-Order Easy-Delivery',
            description: 'At HANSA-FLEX Serbia we provide best of customer service and take care that the quality product is delivered.'
        },

        {
            imgSrc: imgLogistics,
            title: 'We Make it, We deliver it',
            description: 'HANSA-FLEX Serbia ensures hoses and fittings are consistently stocked, guaranteeing uninterrupted operations for clients. With a proactive approach, we prioritize maintaining ample inventory, delivering reliability and efficiency to meet diverse hydraulic system needs.'
        }
    ];


    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        <div>
            <CenterStage imageSrc={imgHANSA_FLEX_SERBIA_STAGE} title={"Welcome to HANSA-FLEX Hidraulika d.o.o."} paragraph={"At HANSA-FLEX Hidraulika d.o.o.., we are your trusted partner for hydraulic solutions, offering exceptional expertise and innovative technologies to meet your needs. As part of the globally renowned HANSA-FLEX network, we are committed to delivering high-quality products and services that empower industries to perform at their best. From customized hydraulic systems to efficient maintenance solutions, we are here to drive your success with precision, reliability, and excellence."} />

            <ThreeDImageCarousel items={carouselData} />
            {/* <FullImageText
                imageSrc={imgVan}
                altText="Service Mobile Van"
                title="Your Hydraulic Solutions on Wheels"
                paragraph="Our service mobile van is equipped with the latest tools and technology to provide on-site hydraulic solutions. Whether it's urgent repairs or routine maintenance, our expert team is ready to deliver exceptional service directly to your location, ensuring minimal downtime and maximum efficiency."
                imageWidth={1}
            /> */}

            {/* <div>
                <ImageText data={dataBrazing} /> <br /><br />
                <ImageText data={dataStock} left={false} /> <br /><br />
            </div> */}

            {/* <div>
                {isLaptop && (
                    <Promoter
                        title={promoterTitle}
                        checklistItems={promoterChecklistItems}
                        btnLabel1={"Find Out More !"}
                        imageUrl={imgTeams}
                    />
                )}
            </div> */}


            <br /><br /><br /><br />


            <div className='div-gray'>
                <SectionHeader title={"Why choose us?"} paragraph={"We are the epitome of excellence, renowned for our unwavering commitment to quality and customer satisfaction."} />
                <FeatureCardCarousel featuresData={featuresData} />
            </div>


            <div>

                <br /><br /><br /><br />
                <ShowcaseCarousel carouselItems={carouselItems} isExploreButton={false} descDisplay='block' carouselType={1} />
            </div>

            <br /><br /><br />
            <br /><br /><br />

            <div className="text-center div-gray">
                <SectionHeader
                    title={"Explore about HANSA-FLEX Group"}
                    paragraph={"HANSA-FLEX is a global family-run company and one of the world’s leading system partners for fluid technology. In the last business year, more than 5,000 employees in 40 countries achieved a turnover of EUR 570 million."} />
                <br />
                <Button variant="danger" href={"https://www.hansa-flex.de/en/company/"} target="_blank" style={{ boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.2)' }}>{t("Learn more about HANSA-FLEX")}</Button>

                <br /><br /><br />
            </div>


            <div>

                <br /><br /><br /><br />

                <div style={{ backgroundColor: '#30557d', padding: '20px', color: 'white', paddingLeft: '10%' }}>
                    <Row>
                        <Col xs={12} md={6}>
                            <h2>{t("Contact details")}:</h2>
                            <p>{t("For further information, assistance or collaboration, please do not hesitate to contact us")}:</p>
                            <p> <MdLocationOn /> {t("Address")}: <a href="https://maps.app.goo.gl/2vkAWPeeXJiddqt86" style={{ textDecoration: 'none', color: 'white' }} > HANSA-FLEX Beograd-Železnik, Lole Ribara 120, 11250 Beograd-Železnik, Serbia</a></p>
                            <p> <MdOutlineEmail /> {t("Email")}: <a href="mailto:info.srb@hansa-flex.com" style={{ textDecoration: 'none', color: 'white' }}> info.srb@hansa-flex.com</a></p>
                            <p> <FaPhoneVolume /> {t("Phone")}: <a href="tel:+381 11 2577 662" style={{ textDecoration: 'none', color: 'white' }} > +381 11 2577 662</a></p>
                        </Col>
                    </Row>
                </div>


            </div>





        </div>
    );
}

export default WhoWeAre;